import React from 'react';
import { SvgIcon } from 'src/ui/common/atoms/svg-icon';
import { StyledThreeDots } from './styles';

export const MoreIcon = React.forwardRef((props, ref) => (
// @ts-ignore
    <StyledThreeDots {...props} ref={ref} alignItems='center' justifyContent='center'>
        <SvgIcon variant='regular' icon='more' />
    </StyledThreeDots>
));

MoreIcon.displayName = 'MoreIcon';

